/* eslint-disable array-callback-return */
/* eslint-disable default-case */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef, useLayoutEffect } from 'react';
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
} from 'react-share';
import Container from '../Container';
import Icon from '../Icons';
import { useGaEvent } from '../../hooks/hooks.ga-events';

const WidgetSocial = ({ date, author }) => {
  const emailButtonRef = useRef(null);
  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';

  const handleGaEvent = (url, social) => {
    useGaEvent('Social Network Click-out', `Content Detail Page::${social}`, url);
  };

  useLayoutEffect(() => {
    emailButtonRef.current.addEventListener('click', () => {
      useGaEvent('Social Network Click-out', 'Content Detail Page::Email', shareUrl);
    });
  }, []);

  return (
    <Container className="widget-social">
      <div className="widget-social__wrapper">
        <div className="widget-social__content">
          <p className="widget-social__text">
            {date && <span className="widget-social__data label-small">{date}</span>}
            {
              author && (
                <span className="widget-social__author label-small">
                  By {author}
                </span>
              )
            }
          </p>
          <ul className="widget-social__social-links">
            <li className="widget-social__item" key="facebook">
              <FacebookShareButton onClick={() => handleGaEvent(shareUrl, 'Facebook')} url={shareUrl}>
                <Icon className="widget-social__icon icon--40" path="social-ico-facebook" />
              </FacebookShareButton>
            </li>
            <li className="widget-social__item" key="twitter">
              <TwitterShareButton onClick={() => handleGaEvent(shareUrl, 'Twitter')} url={shareUrl} hashtags={['UNICEF']}>
                <Icon className="widget-social__icon icon--40" path="social-ico-twitter" />
              </TwitterShareButton>
            </li>
            <li className="widget-social__item" key="email">
              <EmailShareButton
                ref={emailButtonRef}
                subject="Unicef news"
                body={shareUrl}
              >
                <Icon className="widget-social__icon icon--40" path="social-ico-email" />
              </EmailShareButton>
            </li>
          </ul>
        </div>
      </div>
    </Container>
  );
};

/*
WidgetSocial.defaultProps = {
  date: '09/10/2019',
  author: 'Christophe Boulierac',
  socials: [
    {
      name: 'twitter',
      url: ''
    },
    {
      name: 'facebook',
      url: ''
    },
    {
      name: 'email',
      url: ''
    }
  ]
};
 */

export default WidgetSocial;
